<script>
export default {
  components: {},
  data () {
    return {
      id: parseInt(this.$route.params.id) || 0
    }
  },
  created: function () {},
  mounted: function () {},
  beforeDestroy: function () {},
  watch: {},
  methods: {},
  filters: {}
}
</script>

<template>
  <el-container>
    <el-header height="45px" class="clear">
      <el-form :inline="true" class="demo-form-inline left-form" size="small">
        <el-form-item>
          <el-button @click="$router.go(-1)">返 回</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
        <div class="content">
          <user-doctor-info :id="id"></user-doctor-info>
        </div>
      </el-scrollbar>
    </el-main>
  </el-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  width: 680px;
  margin: 20px auto;
  padding: 20px 0;
  border: 1px solid #e1e6eb;
  border-radius: 12px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
</style>
